/* eslint-disable complexity */
import { Benachrichtigungen } from '@/domain/navigation/benachrichtigungen/types/Benachrichtungen';
import { ManagerProfile } from '@/hooks';

export function getBenachrichtigungenCount(
  benachrichtigungen: Benachrichtigungen,
  manager: ManagerProfile,
) {
  let count = 0;

  if (manager.rechte.kalender) {
    count += benachrichtigungen.abwesenheitsantraege.length;
    count += benachrichtigungen.krankmeldungen.length;
  }

  if (
    manager.rechte.arbeitszeit.erlaubt &&
    manager.rechte.arbeitszeit.bearbeiten
  ) {
    count += benachrichtigungen.fehlendeArbeitszeiten.length;
  }

  if (manager.rechte.mitarbeiter.fristen) {
    count += benachrichtigungen.fristen.length;
  }

  if (manager.rechte.mitarbeiter.dokumente) {
    count += benachrichtigungen.dokumente.length;
  }

  if (manager.rechte.mitarbeiter.erlaubt) {
    count += benachrichtigungen.personalfragebogen.length;
  }

  if (manager.rechte.dienstplan.mitarbeiterEinteilen) {
    count += benachrichtigungen.schichttauschAntraege.length;
  }

  return count;
}
